import {Component, OnInit} from '@angular/core';
import {FormControl} from "@angular/forms";
import {Subject} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../store";
import {CustomersService} from "../customers.service";
import {ICustomersParams} from "../../orders/orders.interface";
import {debounceTime, filter, takeUntil, tap} from "rxjs/operators";
import {IEcommerceCustomersEntityState} from "../../../../../store/reducers/ecommerce-customers.reducer";
import {RemoveItemDialogComponent} from "../../products/remove-item-dialog/remove-item-dialog.component";
import {ICustomer} from "../../ecommerce-customer.interface";
import {Config} from "../../../../../config/config";
import {DbModalService} from "../../../../../modules/modal/modal";

@Component({
    selector: 'db-customers-list',
    templateUrl: './customers-list.component.html',
    styleUrls: ['./customers-list.component.scss'],
    standalone: false
})
export class CustomersListComponent implements OnInit {
  searchTerm: FormControl = new FormControl();
  website = this._activatedRoute.snapshot.parent.parent.parent.data['website'];
  loading = false;
  customers: ICustomer[] = [];
  customersCount = 0;
  customersPerPage = 10;
  currentPage = 1;
  private _subscription$: Subject<void> = new Subject<void>();
  isFakeMode = this.website.id === Config.demoDomainId;
  showSearchLoading = false;
  searched = false;

  constructor(private _activatedRoute: ActivatedRoute,
              private _store: Store<fromStore.DbStoreState>,
              private _customersService: CustomersService,
              private _modalService: DbModalService) {
  }

  ngOnInit() {
    this._dispatchCustomers();
    this._getCustomers();
    this._listenSearch();
    this._listenFailure();
  }

  private _dispatchCustomers(showLoading = true) {
    const params: ICustomersParams = {
      websiteId: this.website.id,
      page: this.currentPage,
      per_page: this.customersPerPage,
    };

    if (this.searchTerm.value) {
      params.search = this.searchTerm.value;
      params.searchby = 'email';
    }
    this.loading = showLoading;

    this._store.dispatch(new fromStore.LoadEcommerceCustomers(params));
  }

  private _listenFailure() {
    // this._store.select(fromStore.getCustomersLoading(this.website.id))
    //   .pipe(takeUntil(this._subscription$))
    //   .subscribe((loading: boolean) => this.loading = loading);
  }

  private _getCustomers() {
    this._store.select(fromStore.getCustomers(this.website.id))
      .pipe(
        filter((prodState: IEcommerceCustomersEntityState) => prodState && prodState.loaded),
        takeUntil(this._subscription$)
      ).subscribe((response) => {
      this.customers = response.customers;
      this.customersCount = response.customersCount;
      this.searched = !!this.searchTerm.value;
      this.showSearchLoading = false;
      this.loading = false;
    });
  }

  private _listenSearch() {
    this.searchTerm.valueChanges.pipe(
      tap(() => this.showSearchLoading = true),
      debounceTime(500),
      takeUntil(this._subscription$)
    ).subscribe((searchValue) => {
      this.currentPage = 1;
      this._dispatchCustomers();
    });
  }

  changePage(page: number) {
    this.currentPage = page;
    this._dispatchCustomers();
  }

  onRemoveItem(id: number) {
    this._modalService
      .open(RemoveItemDialogComponent)
      .closed
      .subscribe(value => {
        if (value) {
          this._removeItem(id);
        }
      });
  }

  private _removeItem(id: number) {
    this.loading = true;
    this._customersService.deleteCustomer(this.website.id, id)
      .subscribe((value) => {
        if (value) {
          this._dispatchCustomers();
        }
      });
  }

}
